export default __webpack_public_path__ + "static/media/full_TheShadowKing.af1be631.jpg";